import { dateIsValid } from "utils/validations.utils";
import { create, skipWhen } from "vest";
import { TagChipFormValues } from "./tag-chip-form.component";

export type TagChipFormFieldName = "description" | "expires_at";

export const tagChipFormValidator = () =>
  create((data: TagChipFormValues) => {
    const { expires_at } = data;

    skipWhen(!expires_at, () => {
      dateIsValid<TagChipFormFieldName>(
        "expires_at",
        "Tag End Date",
        expires_at
      );
    });
  });
